import { statusLabel } from "../lib/format";

const styles = {
  matched: "bg-[#F0FDF4] text-[#16A34A] border-[#BBF7D0]",
  overcharge: "bg-[#FFF0F0] text-[#DC2626] border-[#FECACA]",
  missing_from_cms: "bg-[#FFF0F0] text-[#DC2626] border-[#FECACA]",
  missing_from_ups: "bg-[#FEFCE8] text-[#CA8A04] border-[#FEF08A]",
  prp_pending: "bg-[#EFF6FF] text-[#1D4ED8] border-[#BFDBFE]",
};

export default function StatusBadge({ status }) {
  const cls = styles[status] || "bg-[#FAFAFA] text-[#525252] border-[#E5E5E5]";
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-sm text-[11px] font-medium border ${cls} ${
        status === "matched" ? "font-mono-tabular tracking-wider" : ""
      }`}
      data-testid={`status-badge-${status}`}
    >
      {statusLabel[status] || status}
    </span>
  );
}
